import BlockAlert from './BlockAlert'

export default BlockAlert
